import React, { useState } from 'react';
import axios from 'axios';
import { Container, Button, Typography, Paper, Alert } from '@mui/material';

axios.defaults.withCredentials = true;

function GenerateDirectorTokenPage() {
  const [token, setToken] = useState('');
  const [message, setMessage] = useState('');

  const generateToken = async () => {
    try {
      const response = await axios.post('/api/users/generate-director-token');
      setToken(`/register?roleToken=${response.data.token}`);
      setMessage('Invitation generated successfully!');
    } catch (error) {
      setMessage(error.response?.data || 'Failed to generate invitation. Are you an admin?');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Invite Director
        </Typography>
        <Button variant="contained" color="primary" onClick={generateToken} sx={{ mb: 2 }}>
          Generate Invitation
        </Button>
        {token && (
          <Alert severity="success" sx={{ mt: 2 }}>
            <Typography>Generated Invitation Link:</Typography>
            <pre>{token}</pre>
          </Alert>
        )}
        {message && <Alert severity="info" sx={{ mt: 2 }}>{message}</Alert>}
      </Paper>
    </Container>
  );
}

export default GenerateDirectorTokenPage;